module.exports = __webpack_public_path__ + "img/danijellabas.3a222d52.jpg";